import type MailboxInfo from 'owa-client-types/lib/MailboxInfo';
import { isBizchatSidepaneEnabled } from 'owa-bizchat-shared/lib/utils/isBizchatSidepaneEnabled';
import isCopilotChatEnabled from 'owa-officeai-copilot-chat-shared/lib/utils/isCopilotChatEnabled';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Function to determine if chat is enabled for the given mailbox.
 * Important to use this function as we currently support BizChat & Copilot Chat
 */
export function isChatEnabled(
    mailboxInfo: MailboxInfo,
    shouldIgnoreUserPreferences?: boolean
): boolean {
    return isGlobalFeatureEnabled('mon-copilot-bizchat')
        ? !!isBizchatSidepaneEnabled(mailboxInfo, shouldIgnoreUserPreferences)
        : !!isCopilotChatEnabled(mailboxInfo, shouldIgnoreUserPreferences);
}
